import { format } from 'd3-format'
import { ReactNode } from 'react'

/**
 * Renders an array of strings as comma-separated values
 */
export const RenderStringArray = ({ values }: { values: string[] }): ReactNode => {
  return values.join(', ')
}

/**
 * Renders an array of numbers as comma-separated values with optional formatting
 */
export const RenderNumberArray = ({ values, formatter }: { values: number[]; formatter?: string }): ReactNode => {
  return values.map((item) => (formatter ? format(formatter)(item) : item.toString())).join(', ')
}
